import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import { Field, FieldProps, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { TextField } from '../../../components/TextField';
import type { OnSubmit } from '../../../design-system';
import { createSchema } from '../../../utils/formUtils';

type MfaChallengeFormFields = { code: string };

const initialValues: MfaChallengeFormFields = { code: '' };

const validationSchema = createSchema<MfaChallengeFormFields>({
  code: Yup.string()
    .required()
    .matches(/^[0-9]+$/, 'Must be only digits')
    .min(6, 'Must be exactly 6 digits')
    .max(6, 'Must be exactly 6 digits'),
});

export interface MfaChallengeFormProps {
  onSubmit: OnSubmit<MfaChallengeFormFields>;
}

export const MfaChallengeForm: React.FC<MfaChallengeFormProps> = ({ onSubmit }) => (
  <Fade in>
    <div>
      <Formik<MfaChallengeFormFields>
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ errors, isSubmitting }) => (
          <Form>
            <Box>
              <Field name="code">
                {({ field: { onBlur, onChange, name, value } }: FieldProps<MfaChallengeFormFields['code']>) => (
                  <TextField
                    autoComplete="off"
                    autoFocus
                    disabled={isSubmitting}
                    error={!!errors.code}
                    fullWidth
                    helperText={errors.code}
                    inputElementProps={{ maxLength: 6 }}
                    label="Code"
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    size="medium"
                    type="text"
                    value={value}
                  />
                )}
              </Field>
            </Box>
            <Box mt={3}>
              <Button color="primary" disabled={isSubmitting} fullWidth size="large" type="submit" variant="contained">
                {isSubmitting ? <CircularProgress size={26} color="inherit" /> : 'Submit'}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  </Fade>
);
